/* The Green Sin — delivery-day line, cut-off countdown and pincode check.
   Rules (all in IST): order by 22:00 → cut at dawn, delivered next evening.
   No Sunday delivery: anything that would land on Sunday lands Monday.
   Saturday delivery is a separate option at checkout. */
(function () {
  if (window.customElements && customElements.get('tgs-delivery')) return;

  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var CUTOFF_MIN = 22 * 60;

  function istNow() {
    var d = new Date();
    return new Date(d.getTime() + (330 + d.getTimezoneOffset()) * 60000); // wall-clock IST in local fields
  }

  function plan() {
    var now = istNow();
    var mins = now.getHours() * 60 + now.getMinutes();
    var beforeCutoff = mins < CUTOFF_MIN;
    var offset = beforeCutoff ? 1 : 2;
    var target = new Date(now.getFullYear(), now.getMonth(), now.getDate() + offset);
    if (target.getDay() === 0) target = new Date(target.getFullYear(), target.getMonth(), target.getDate() + 1);
    var left = CUTOFF_MIN - mins;
    var dayIdx = Math.round((target - new Date(now.getFullYear(), now.getMonth(), now.getDate())) / 86400000);
    return {
      beforeCutoff: beforeCutoff,
      hoursLeft: Math.floor(left / 60),
      minsLeft: left % 60,
      dayName: DAYS[target.getDay()],
      isTomorrow: dayIdx === 1,
      todayIdx: now.getDay(),
      isSat: now.getDay() === 6
    };
  }

  function lineText(p, mode) {
    var when = p.isTomorrow ? 'tomorrow (' + p.dayName + ') evening' : p.dayName + ' evening';
    var s;
    if (p.beforeCutoff) {
      var t = p.hoursLeft > 0 ? p.hoursLeft + ' h ' + p.minsLeft + ' m' : p.minsLeft + ' min';
      s = 'Order in the next ' + t + ' and it’s cut at dawn — with you ' + when + '.';
    } else {
      s = 'Past tonight’s 10 PM cut-off — orders placed now arrive ' + when + '.';
    }
    if (p.dayName === 'Monday' && (p.todayIdx === 5 && !p.beforeCutoff || p.todayIdx === 6 || p.todayIdx === 0)) {
      s += ' The farm rests on Sunday, so weekend orders ride Monday’s van.';
    }
    return s;
  }

  function checkPin(v) {
    v = (v || '').replace(/\D/g, '');
    if (v.length < 6) return null;
    if (/^110\d{3}$/.test(v)) return { ok: true, area: 'Delhi' };
    if (/^122\d{3}$/.test(v)) return { ok: true, area: 'Gurgaon' };
    if (/^20130[134579]$/.test(v)) return { ok: true, area: 'Noida' }; // Noida proper; Greater Noida / Noida Extension (201306, 201308, 201310+) not yet
    return { ok: false };
  }

  class TgsDelivery extends HTMLElement {
    connectedCallback() {
      this.render();
      var self = this;
      if (!this._timer) this._timer = setInterval(function () { self.render(); }, 60000);
      var input = this.querySelector('[data-tgs-pin]');
      if (input) {
        var saved = null;
        try { saved = localStorage.getItem('tgs-pin'); } catch (e) {}
        if (saved && !input.value) { input.value = saved; this.showPin(saved); }
        input.addEventListener('input', function () { self.showPin(input.value); });
      }
    }
    disconnectedCallback() { if (this._timer) { clearInterval(this._timer); this._timer = null; } }
    render() {
      var el = this.querySelector('[data-tgs-line]');
      if (!el) return;
      var p = plan();
      el.textContent = lineText(p, this.dataset.mode);
      var sat = this.querySelector('[data-tgs-sat]');
      if (sat) sat.hidden = (p.todayIdx === 5 && p.beforeCutoff) || p.dayName === 'Saturday';
    }
    showPin(v) {
      var out = this.querySelector('[data-tgs-pin-result]');
      if (!out) return;
      var r = checkPin(v);
      out.className = 'tgs-delivery__pin-result';
      if (!r) { out.textContent = ''; return; }
      if (r.ok) {
        out.textContent = r.area + ' — yes, we deliver to you.';
        out.classList.add('is-ok');
        try { localStorage.setItem('tgs-pin', v.replace(/\D/g, '')); } catch (e) {}
      } else {
        out.textContent = 'Not yet — we’re in Delhi, Gurgaon and Noida for now. If you’re just outside, message us on WhatsApp and we’ll see what we can do.';
        out.classList.add('is-no');
      }
    }
  }
  customElements.define('tgs-delivery', TgsDelivery);

  /* ---- the vine: set progress on any [data-tgs-vine] ---- */
  function setVine(svg, pct) {
    if (!svg) return;
    pct = Math.max(0, Math.min(100, pct));
    var lastNode = Math.floor(pct / 10) * 10; // a leaf or a tomato every ₹50
    var stem = pct >= 100 ? 100 : lastNode + (pct - lastNode) * 0.5; // nudge past the last node, never far
    svg.style.setProperty('--pct', stem.toFixed(1));
    svg.querySelectorAll('.tgs-vine__node').forEach(function (node) {
      node.classList.toggle('is-on', pct >= parseInt(node.dataset.at, 10));
    });
    var flower = svg.querySelector('.tgs-vine__flower');
    if (flower) flower.classList.toggle('is-bloom', pct >= 100);
    svg.classList.toggle('tgs-vine--bloom', pct >= 100);
  }
  window.tgsVine = setVine;
  window.tgsDeliveryPlan = plan;

  /* ---- "engaged": the strip and the rail stay out of the way until the first click (or a basket) ---- */
  var engaged = false;
  try { engaged = sessionStorage.getItem('tgs-engaged') === '1'; } catch (e) {}
  var engagedListeners = [];
  function onEngaged(fn) { engagedListeners.push(fn); }
  if (!engaged) {
    var onFirstClick = function (ev) {
      var el = ev.target && ev.target.closest ? ev.target.closest('a, button, summary, label, input, select, [role="button"]') : null;
      if (!el) return;
      engaged = true;
      try { sessionStorage.setItem('tgs-engaged', '1'); } catch (e) {}
      document.removeEventListener('click', onFirstClick, true);
      engagedListeners.forEach(function (fn) { fn(); });
    };
    document.addEventListener('click', onFirstClick, true);
  }

  function fetchCart(cb) {
    fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(cb)
      .catch(function () {});
  }
  function onCartChange(fn) {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, fn);
    }
    var drawerBox = document.getElementById('CartDrawer'); // belt and braces: any drawer re-render means the cart changed
    if (drawerBox && window.MutationObserver) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(fn, 150); }).observe(drawerBox, { childList: true });
    }
    window.addEventListener('pageshow', fn);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) fn(); });
  }

  /* ---- the harvest strip: time left to order ---- */
  var WINDOW_START_MIN = 6 * 60; // the ring counts down the ordering day, 6 AM → 10 PM

  class TgsStrip extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.header = document.querySelector('.section-header') || document.querySelector('.shopify-section-group-header-group:has(header)');
      this.tick();
      this.refresh();
      if (!this._timer) this._timer = setInterval(function () { self.tick(); }, 30000);
      var onScroll = function () { self.place(); };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      if (this.header) this.header.addEventListener('transitionend', onScroll);
      this.place();
      onEngaged(function () { self.refresh(); });
      onCartChange(function () { self.refresh(); });
    }
    disconnectedCallback() { if (this._timer) { clearInterval(this._timer); this._timer = null; } }
    place() {
      var self = this;
      var top = this.header ? Math.max(0, Math.round(this.header.getBoundingClientRect().bottom)) : 0;
      this.style.top = top + 'px';
      if (this._raf) cancelAnimationFrame(this._raf);
      this._raf = requestAnimationFrame(function () { // header slides in/out over a few frames
        if (self.header) self.style.top = Math.max(0, Math.round(self.header.getBoundingClientRect().bottom)) + 'px';
      });
    }
    tick() {
      var p = plan();
      var now = istNow();
      var mins = now.getHours() * 60 + now.getMinutes();
      var left = 100;
      if (!p.beforeCutoff) left = 0;
      else if (mins > WINDOW_START_MIN) left = Math.max(0, Math.min(100, (CUTOFF_MIN - mins) / (CUTOFF_MIN - WINDOW_START_MIN) * 100));
      var ring = this.querySelector('[data-tgs-ring]');
      if (ring) ring.style.setProperty('--left', left.toFixed(1));
      this.classList.toggle('tgs-strip--late', p.beforeCutoff && p.hoursLeft < 2);
      this.classList.toggle('tgs-strip--closed', !p.beforeCutoff);
      var dayWord = p.isTomorrow ? 'tomorrow’s' : p.dayName + '’s';
      var longEl = this.querySelector('[data-tgs-strip-long]');
      var shortEl = this.querySelector('[data-tgs-strip-short]');
      if (p.beforeCutoff) {
        var t = p.hoursLeft > 0 ? p.hoursLeft + ' h ' + p.minsLeft + ' m' : p.minsLeft + ' min';
        longEl.textContent = (p.hoursLeft < 2 ? 'Last call — ' : '') + t + ' left to order for ' + dayWord + ' delivery' + (p.isTomorrow ? ' (' + p.dayName + ', 5–8 PM)' : ' (5–8 PM)');
        shortEl.textContent = t + ' left for ' + dayWord + ' delivery';
      } else {
        longEl.textContent = 'Closed for tonight — orders placed now are delivered ' + p.dayName + ' evening, 5–8 PM';
        shortEl.textContent = 'Closed for tonight · delivered ' + p.dayName.slice(0, 3);
      }
    }
    refresh() {
      var self = this;
      fetchCart(function (cart) {
        var on = engaged || (cart && cart.item_count > 0);
        self.hidden = !on;
        document.documentElement.classList.toggle('tgs-strip-on', on);
        if (on) self.place();
      });
    }
  }
  customElements.define('tgs-strip', TgsStrip);

  /* ---- the rail: tomato vine on the right edge ---- */
  function rupees(paise) {
    var r = paise / 100;
    return '₹' + (Math.round(r * 100) / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 });
  }

  var TOMATO = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="13.5" r="9" fill="#D8402C" stroke="rgba(0,0,0,.18)" stroke-width=".6"/><circle cx="8.5" cy="10.5" r="2.2" fill="rgba(255,255,255,.45)"/><path d="M12 4.5 l -4 -1.5 M12 4.5 l 4 -1.5 M12 4.5 l -2.4 -3 M12 4.5 l 2.6 -2.8 M12 4.5 v 2.5" fill="none" stroke="#6FA35A" stroke-width="1.5" stroke-linecap="round"/></svg>';

  function rainTomatoes() {
    if (document.querySelector('.tgs-rain')) return;
    var wrap = document.createElement('div');
    wrap.className = 'tgs-rain';
    var n = window.innerWidth < 750 ? 26 : 44;
    for (var i = 0; i < n; i++) {
      var d = document.createElement('div');
      d.className = 'tgs-rain__drop';
      d.style.left = (Math.random() * 100) + 'vw';
      d.style.setProperty('--size', (16 + Math.random() * 18).toFixed(0) + 'px');
      d.style.setProperty('--dur', (1.5 + Math.random() * 1.05).toFixed(2) + 's'); // 1.5× faster than the first cut
      d.style.setProperty('--delay', (Math.random() * 0.8).toFixed(2) + 's');
      d.style.setProperty('--drift', ((Math.random() - 0.5) * 120).toFixed(0) + 'px');
      d.style.setProperty('--spin', ((Math.random() - 0.5) * 900).toFixed(0) + 'deg');
      d.innerHTML = TOMATO;
      wrap.appendChild(d);
    }
    document.body.appendChild(wrap);
    setTimeout(function () { if (wrap.parentNode) wrap.parentNode.removeChild(wrap); }, 3600);
  }
  window.tgsRainTomatoes = rainTomatoes;

  class TgsRail extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.threshold = parseInt(this.dataset.threshold, 10) || 50000;
      this.wasFree = null; // unknown until the first cart read; rain only on a real crossing
      this.querySelector('[data-tgs-rail-cart]').addEventListener('click', function () {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open(self.querySelector('[data-tgs-rail-cart]'));
        else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      });
      this.refresh();
      onEngaged(function () { self.refresh(); });
      onCartChange(function () { self.refresh(); });
    }
    refresh() {
      var self = this;
      fetchCart(function (cart) { self.apply(cart); });
    }
    apply(cart) {
      var hasItems = cart && cart.item_count > 0;
      var on = hasItems || engaged;
      this.hidden = !on;
      var pill = this.querySelector('[data-tgs-rail-pill]');
      var total = hasItems ? cart.total_price : 0;
      var free = total >= this.threshold;
      if (this.wasFree === false && free) rainTomatoes();
      this.wasFree = free;
      if (!on) return;
      this.classList.toggle('tgs-rail--free', free);
      if (!hasItems) pill.textContent = 'Free delivery over ₹500';
      else if (free) pill.textContent = 'Free delivery ✓';
      else pill.textContent = rupees(this.threshold - total) + ' to go';
      setVine(this.querySelector('[data-tgs-vine]'), total * 100 / this.threshold);
    }
  }
  customElements.define('tgs-rail', TgsRail);
})();
